
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ja. Allerdings ist die Antwort ziemlich freud- und lustlos. Und sie setzt eine Menge Disziplin des Schnarchenden voraus: abnehmen, gesunde Ernährung, kein Alkohol, vor allem nicht vor dem Einschlafen, und keine Zigaretten. Dafür regelmässige Bewegung. Alle diese Massnahmen haben das Ziel, die Engstelle im Rachen zu beheben und den Atemfluss zu verbessern. Ebenso sollte auf Schlafmittel verzichtet werden. Diese wirken muskelentspannend und fördern so das Schnarchen. Wird das nächtliche Sägen zu einer grossen Belastung – für die Betroffenen selbst oder für den Partner –, können verschiedene Schnarchstopp-Gadgets Abhilfe schaffen. Experten empfehlen Anti-Schnarch-Schienen, die den Unterkiefer nach vorne schieben, oder einen Draht, der den Gaumen nach oben drückt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;